import React from "react";

function NoTableData_Jupiter() {
  return (
    <>
      <tr>
        <td colSpan={2}>No data found</td>
      </tr>
    </>
  );
}

export default NoTableData_Jupiter;